import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { getClientWarehouseCode } from '../../../api/shipping/get-client-warehouse-code'
import { setSnackbar } from '../../GenericSnackbar/generic-snackbar-slice'
import Constants from '../../../constants/en.json'
import { sessionStorageKeyConstants } from '../../../constants/session-storage-key-constants'
import GenericAutocomplete from '../GenericAutocomplete/generic-autocomplete'

export function SelectClientDropdown({ currentState, handleSelectOption }) {
  const dispatch = useDispatch()
  const clients = useSelector((state) => state.staticData.clients)
  /* Options is an array of objects of id and description fields */
  const clientDropdownOptions = clients.map((item) => {
    return { id: item.clientCode, description: item.clientShortName }
  })
  /* Filtering selected dropdown option based on the selection
     option captured from session storage */
  const currentClient = currentState
    ? clientDropdownOptions.filter((item) => item.id === currentState.clientCode)[0]
    : null
  /* Set the current selected value */
  const [selectedClient, setSelectedClient] = useState(currentClient)

  const handleSelectClient = (selectedValue) => {
    setSelectedClient(selectedValue)
    const client = clients.filter((item) => item.clientCode === selectedValue.id)[0]
    sessionStorage.setItem(sessionStorageKeyConstants.SELECTED_CLIENT, JSON.stringify(client))
    getClientWarehouseCode(selectedValue.id)
      .then((response) => {
        sessionStorage.setItem(
          sessionStorageKeyConstants.SELECTED_WAREHOUSE_CODES,
          response?.data?.data?.warehouseCodes,
        )
        handleSelectOption(client)
      })
      .catch(() => {
        const message = Constants.userManagement.errors.UNABLE_TO_FETCH_WAREHOUSE_DETAILS
        dispatch(setSnackbar({ message, severity: 'error', action: true }))
      })
  }

  return (
    <GenericAutocomplete
      width='259px'
      label={Constants.clientSelection.CLIENT}
      dropdownOptions={clientDropdownOptions}
      selectedOption={selectedClient}
      handleSelectOption={handleSelectClient}
    />
  )
}

SelectClientDropdown.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  currentState: PropTypes.any,
  handleSelectOption: PropTypes.func.isRequired,
}

export default SelectClientDropdown
